import React, { useState } from "react";
import { FunnelIcon, PlusCircleIcon } from "@heroicons/react/24/outline";
import CustomDropdown from "../../../dropdown/CustomDropdown";
import { templateCardDetail } from "../adminData";
import Button from "../../../button";
import { useNavigate } from "react-router-dom";
import AdminEmailSlideOver from "../slideovers/AdminEmailSlideOver";

const templateOptions = [
  {
    id: 1,
    value: "Course category",
  },
  {
    id: 2,
    value: "Course category 2",
  },
  {
    id: 3,
    value: "Course category 3",
  },
];

const EmailTemplatesPage = () => {
  const [emailSlideOver, setEmailSlideOver] = useState(false);

  const navigate = useNavigate();
  const mode = "create";
  const handleEmailTemplate = () => {
    navigate(`/admin-dashboard/admin-tools/email-templates/${mode}`);
  };

  const handleEmailSlideOverClose = () => {
    setEmailSlideOver(false);
  };

  return (
    <div className="col-span-12 -mt-3">
      <div className="flex md:items-center justify-between gap-5 flex-col md:flex-row mb-5">
        <div className="flex md:block justify-between items-center">
          <h4 className="text-xl md:text-2xl font-bold leading-[130%] md:leading-[180%] text-[#04091E]">
            Email Templates
          </h4>
          <button
            className="w-12 h-12 flex md:hidden justify-center items-center rounded-[10px] bg-primary cursor-pointer"
            // onClick={() => setCourseSlideOver(true)}
          >
            <PlusCircleIcon
              className="w-6 h-6 text-white"
              onClick={handleEmailTemplate}
            />
          </button>
        </div>
        <div className="flex items-center md:justify-end gap-[30px] w-full md:w-[50%]">
          <CustomDropdown
            options={templateOptions.map((data) => data.name)}
            icon={FunnelIcon}
            classes="px-[14px] py-3 border w-full md:w-[274px] border-solid border-[#EBEFF3] rounded-[10px] h-[48px] bg-[#FFFFFF] flex items-center justify-between"
            textClasses="inline-flex w-full items-center text-left gap-x-[10px] text-sm font-medium text-[#485868]"
            leftIconClasses="icon w-6 h-6 text-customGray"
            rightIconClasses="-mr-1 h-6 w-6 text-[#485868] font-bold"
            menuClasses="absolute left-0 z-10 mt-4 w-full origin-top rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
          />
          <button
            className="w-12 h-12 hidden md:flex justify-center items-center rounded-[10px] bg-primary cursor-pointer"
            // onClick={() => setCourseSlideOver(true)}
          >
            <PlusCircleIcon
              className="w-6 h-6 text-white"
              onClick={handleEmailTemplate}
            />
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
        {templateCardDetail.map((item) => (
          <div className="p-5 border border-[#EBEFF3] rounded-md bg-white">
            <div className="flex items-center justify-between pb-3.5 mb-3.5 border-b border-[#EBEFF3]">
              <h6 className="text-base font-bold leading-[160%] text-customGray capitalize">
                {item.title}
              </h6>
            </div>
            <div className="mb-5">
              <p className="mb-2.5 text-sm font-normal leading-[140%] text-[#485868] md:min-h-[60px] xl:min-h-[80px] xxl:min-h-[60px]">
                {item.description}
              </p>
              <span className="text-sm font-bold leading-[140%] text-[#485868] capitalize">
                Event: {item.event}
              </span>
            </div>
            <Button
              title="view more"
              classes="text-sm font-black leading-[160%] text-primary uppercase bg-white h-10 border border-primary rounded-[10px] flex items-center justify-center transition-all hover:bg-primary hover:text-white w-full"
              onClick={() => setEmailSlideOver(true)}
            />
          </div>
        ))}
      </div>
      <AdminEmailSlideOver
        show={emailSlideOver}
        setCourseSlideOver={setEmailSlideOver}
        handleClose={handleEmailSlideOverClose}
        type="Create"
      />
    </div>
  );
};

export default EmailTemplatesPage;
